// src/pages/NotFound.js
import React from 'react';
import { useDispatch, useSelector } from "react-redux";

import { Link } from 'react-router-dom';
import { MdErrorOutline } from 'react-icons/md';
import styles from './NotFound.module.scss';

function NotFound() {
  const user = useSelector((state) => state.auth.login.currentUser);
  console.log(user)
  return (
    <div className={styles.container}>
      <MdErrorOutline className={styles.icon} />
      <h1>404 - Không tìm thấy trang</h1>
      <p>Rất tiếc! Trang bạn đang tìm kiếm không tồn tại hoặc đã bị xóa.</p>
      <div
        onClick={() => window.location.href = user?.admin ? '/admin' : "/"}
        className={styles.homeBtn}
      >Quay về trang chủ</div>
    </div>
  );
}

export default NotFound;
